export const CHANGE_PASSWORD_SESSION_EXPIRED =
  'Your session has expired. Please log in again.';

export const CHANGE_PASSWORD_NETWORK_ERROR =
  'Unable to change your password right now. Please check your connection and try again.';

export const CHANGE_PASSWORD_GENERIC_ERROR =
  'Something went wrong while changing your password. Please try again.';

export const CHANGE_PASSWORD_CURRENT_INCORRECT =
  'Current password is incorrect.';

export const CHANGE_PASSWORD_SAME_AS_CURRENT =
  'Your new password must be different from your current password.';

const messageOf = (error) => String(error?.message || error || '').toLowerCase();

export const mapChangePasswordError = (error) => {
  const message = messageOf(error);
  const name = String(error?.name || '').toLowerCase();
  const status = Number(error?.status || error?.statusCode || 0);

  if (
    name === 'typeerror'
    || message.includes('failed to fetch')
    || message.includes('networkerror')
    || message.includes('network request failed')
    || message.includes('load failed')
  ) {
    return CHANGE_PASSWORD_NETWORK_ERROR;
  }

  if (
    status === 401
    || (message.includes('session') && (message.includes('expired') || message.includes('missing')))
    || message.includes('jwt expired')
    || message.includes('not authenticated')
    || message.includes('auth session missing')
  ) {
    return CHANGE_PASSWORD_SESSION_EXPIRED;
  }

  if (
    message.includes('invalid login credentials')
    || message.includes('invalid_credentials')
  ) {
    return CHANGE_PASSWORD_CURRENT_INCORRECT;
  }

  if (
    message.includes('same as the old')
    || message.includes('should be different')
    || message.includes('different from the old')
    || message.includes('new password should be different')
  ) {
    return CHANGE_PASSWORD_SAME_AS_CURRENT;
  }

  return CHANGE_PASSWORD_GENERIC_ERROR;
};
